// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { hashtag16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-hashtag': IconHashtag;
    }
}

/**
 * The icon component for the 'hashtag' icon
 */
export class IconHashtag extends IconSvg {
    public constructor() {
        super(hashtag16X16);
    }
}

registerIconSvg('icon-hashtag', IconHashtag);
export const iconHashtagTag = 'nimble-icon-hashtag';
